import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import formatTimestampForNotification from "../lib/formatTimestampForNotification";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../FirebaseConfig";
import { UserAuth } from "../Context";
import formatPrice from "../lib/formatPrice";

function ProductPriceChange({ notification }) {
  const [isSeen, setIsSeen] = useState(notification.seen);
  const navigate = useNavigate();
  const { user } = UserAuth();

  const handleNavigate = async () => {
    try {
      // Navigate to the dynamic route
      navigate(`/ProductDetails/${notification.productId}`);

      // Update the 'seen' attribute to true in Firestore
      if (!isSeen) {
        setIsSeen(true);
        const notificationRef = doc(
          db,
          "users",
          user?.uid,
          "notifications",
          notification.notificationId
        );
        await updateDoc(notificationRef, { seen: true });
      }
    } catch (error) {
      console.error("Error updating notification: ", error);
    }
  };

  return (
    <>
      <li
        onClick={handleNavigate}
        className="border-bottom"
        style={{
          padding: "0.625rem 1rem",
          cursor: "pointer",
          backgroundColor: !isSeen ? "#EFF6FF" : "transparent",
        }}
      >
        <div
          className={`d-flex my-0`}
          style={{ display: "inline-flex", gap: "12px", cursor: "pointer" }}
        >
          <div
            style={{ height: "50px", width: "50px" }}
            className={`avatar text-center d-inline-block`}
          >
            <img
              class="avatar-img rounded"
              src={notification?.imageUrl}
              alt=""
            />
          </div>
          <div
            className={`w-100 rounded-2 p-0 d-flex align-items-center justify-content-center `}
          >
            <div
              className="w-100 d-flex gap-2 flex-column justify-content-between p-0"
              style={{
                fontFamily: "Inter",
                color: "#676A79",
                fontWeight: 600,
              }}
            >
              <div className="d-flex flex-grow-1">
                <p className={`small mb-0 d-flex flex-column`}>
                  <span
                    className="d-flex"
                    style={{
                      fontFamily: "Inter",
                      color: "#000000",
                      fontWeight: 500,
                      fontSize: "16px",
                    }}
                  >
                    <div
                      className="text-truncate"
                      style={{ maxWidth: "11rem" }}
                    >
                      {notification?.name}
                    </div>
                    <div>
                      {" - "}
                      <i className="grey">{notification?.supplier}</i>
                    </div>
                  </span>
                  <span style={{ fontSize: "15px" }}>
                    Price changed to{" "}
                    <b>PKR {formatPrice(notification.newPrice)}</b>{" "}
                    <small className=" text-decoration-line-through ">
                      PKR&nbsp;{formatPrice(notification.oldPrice)}
                    </small>
                    .{" "}
                  </span>
                </p>
              </div>
              <div className="small mb-1" style={{ fontSize: "12px" }}>
                {formatTimestampForNotification(notification.timestamp)}
              </div>
            </div>
          </div>
        </div>
      </li>
    </>
  );
}

export default ProductPriceChange;
